/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "noTranslations": true,
  "enabledByDefault": true,
  "name": "Select stage colors in the costume editor",
  "description": "Allows the costume editor's eye dropper to also pick colors from the stage.",
  "credits": [
    {
      "name": "GarboMuffin"
    }
  ],
  "tags": [
    "new"
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "dynamicDisable": true
};
export default manifest;
